import { render, staticRenderFns } from "./RxdFooterMobDropdownItem.vue?vue&type=template&id=734f2982&scoped=true&"
import script from "./RxdFooterMobDropdownItem.vue?vue&type=script&lang=js&"
export * from "./RxdFooterMobDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./RxdFooterMobDropdownItem.vue?vue&type=style&index=0&id=734f2982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734f2982",
  null
  
)

export default component.exports